export default "/content/plugin-channel-alarms/210887c419e07c4439403d4bece7be35.wav";